import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationDetoxificationPhase1DiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp1a1 = getGenePalette(geneColors.CYP1A1);
  const cyp1a2 = getGenePalette(geneColors.CYP1A2);
  const cyp1b1 = getGenePalette(geneColors.CYP1B1);
  const cyp2a6 = getGenePalette(geneColors.CYP2A6);
  const cyp2c9 = getGenePalette(geneColors.CYP2C9);
  const cyp2d6 = getGenePalette(geneColors.CYP2D6);
  const cyp3a4 = getGenePalette(geneColors.CYP3A4);
  const cyp2r1 = getGenePalette(geneColors.CYP2R1);
  const cyp4f2 = getGenePalette(geneColors.CYP4F2);
  const cyp2e1 = getGenePalette(geneColors.CYP2E1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18382_42117)">
        <rect width={1024} height={871} transform="translate(0 142)" fill="white" />
        <g id="detoxification-diagram">
          <rect width={1024} height={871} transform="translate(0 142)" fill="white" />
          <g id="background">
            <rect width={917} height={745} transform="translate(51 205)" fill="#FFF1F2" />
            <g id="Report titles">
              <text
                id="25-Hydroxy Vitamin D"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={67.9609} y={242.16}>
                  Liver
                </tspan>
              </text>
            </g>
            <g id="gene-CYP1A1" {...geneGroupProps("CYP1A1", onGeneClick)}>
              <g id="gene-lozenge_5">
                <path
                  d="M465 359.5C465 357.291 466.791 355.5 469 355.5H561C563.209 355.5 565 357.291 565 359.5V387.5C565 389.709 563.209 391.5 561 391.5H469C466.791 391.5 465 389.709 465 387.5V359.5Z"
                  fill={cyp1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={489.266} y={378.948}>
                    CYP1A1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1a1"
                groupId="gene-snps"
                genePalette={cyp1a1}
                startX={473}
                startY={393.5}
                snpCount={getGeneSnpCount("CYP1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP1A2" {...geneGroupProps("CYP1A2", onGeneClick)}>
              <g id="gene-lozenge_6">
                <path
                  d="M465 411.5C465 409.291 466.791 407.5 469 407.5H561C563.209 407.5 565 409.291 565 411.5V439.5C565 441.709 563.209 443.5 561 443.5H469C466.791 443.5 465 441.709 465 439.5V411.5Z"
                  fill={cyp1a2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={487.461} y={430.948}>
                    CYP1A2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1a2"
                groupId="gene-snps_2"
                genePalette={cyp1a2}
                startX={473}
                startY={445.5}
                snpCount={getGeneSnpCount("CYP1A2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP1B1" {...geneGroupProps("CYP1B1", onGeneClick)}>
              <g id="gene-lozenge_7">
                <path
                  d="M465 463.5C465 461.291 466.791 459.5 469 459.5H561C563.209 459.5 565 461.291 565 463.5V491.5C565 493.709 563.209 495.5 561 495.5H469C466.791 495.5 465 493.709 465 491.5V463.5Z"
                  fill={cyp1b1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_3"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={489.328} y={482.948}>
                    CYP1B1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1b1"
                groupId="gene-snps_3"
                genePalette={cyp1b1}
                startX={473}
                startY={497.5}
                snpCount={getGeneSnpCount("CYP1B1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2A6" {...geneGroupProps("CYP2A6", onGeneClick)}>
              <g id="gene-lozenge_8">
                <path
                  d="M465 515.5C465 513.291 466.791 511.5 469 511.5H561C563.209 511.5 565 513.291 565 515.5V543.5C565 545.709 563.209 547.5 561 547.5H469C466.791 547.5 465 545.709 465 543.5V515.5Z"
                  fill={cyp2a6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_4"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={486.086} y={534.948}>
                    CYP2A6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2a6"
                groupId="gene-snps_4"
                genePalette={cyp2a6}
                startX={473}
                startY={549.5}
                snpCount={getGeneSnpCount("CYP2A6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2C9" {...geneGroupProps("CYP2C9", onGeneClick)}>
              <g id="gene-lozenge_9">
                <path
                  d="M465 567.5C465 565.291 466.791 563.5 469 563.5H561C563.209 563.5 565 565.291 565 567.5V595.5C565 597.709 563.209 599.5 561 599.5H469C466.791 599.5 465 597.709 465 595.5V567.5Z"
                  fill={cyp2c9.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_5"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={485.492} y={586.948}>
                    CYP2C9
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2c9"
                groupId="gene-snps_5"
                genePalette={cyp2c9}
                startX={473}
                startY={601.5}
                snpCount={getGeneSnpCount("CYP2C9", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2D6" {...geneGroupProps("CYP2D6", onGeneClick)}>
              <g id="gene-lozenge_10">
                <path
                  d="M465 622.5C465 620.291 466.791 618.5 469 618.5H561C563.209 618.5 565 620.291 565 622.5V650.5C565 652.709 563.209 654.5 561 654.5H469C466.791 654.5 465 652.709 465 650.5V622.5Z"
                  fill={cyp2d6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_6"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={485.484} y={641.948}>
                    CYP2D6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2d6"
                groupId="gene-snps_6"
                genePalette={cyp2d6}
                startX={473}
                startY={656.5}
                snpCount={getGeneSnpCount("CYP2D6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP3A4" {...geneGroupProps("CYP3A4", onGeneClick)}>
              <g id="gene-lozenge_11">
                <path
                  d="M465 674.5C465 672.291 466.791 670.5 469 670.5H561C563.209 670.5 565 672.291 565 674.5V702.5C565 704.709 563.209 706.5 561 706.5H469C466.791 706.5 465 704.709 465 702.5V674.5Z"
                  fill={cyp3a4.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_7"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={485.969} y={693.948}>
                    CYP3A4
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp3a4"
                groupId="gene-snps_7"
                genePalette={cyp3a4}
                startX={473}
                startY={708.5}
                snpCount={getGeneSnpCount("CYP3A4", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2R1" {...geneGroupProps("CYP2R1", onGeneClick)}>
              <g id="gene-lozenge_12">
                <path
                  d="M465 726.5C465 724.291 466.791 722.5 469 722.5H561C563.209 722.5 565 724.291 565 726.5V754.5C565 756.709 563.209 758.5 561 758.5H469C466.791 758.5 465 756.709 465 754.5V726.5Z"
                  fill={cyp2r1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_8"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={487.867} y={745.948}>
                    CYP2R1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2r1"
                groupId="gene-snps_8"
                genePalette={cyp2r1}
                startX={473}
                startY={760.5}
                snpCount={getGeneSnpCount("CYP2R1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP4F2" {...geneGroupProps("CYP4F2", onGeneClick)}>
              <g id="gene-lozenge_13">
                <path
                  d="M465 778.5C465 776.291 466.791 774.5 469 774.5H561C563.209 774.5 565 776.291 565 778.5V806.5C565 808.709 563.209 810.5 561 810.5H469C466.791 810.5 465 808.709 465 806.5V778.5Z"
                  fill={cyp4f2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_9"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={486.969} y={797.948}>
                    CYP4F2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp4f2"
                groupId="gene-snps_9"
                genePalette={cyp4f2}
                startX={473}
                startY={812.5}
                snpCount={getGeneSnpCount("CYP4F2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2E1" {...geneGroupProps("CYP2E1", onGeneClick)}>
              <g id="gene-lozenge_14">
                <path
                  d="M465 830.5C465 828.291 466.791 826.5 469 826.5H561C563.209 826.5 565 828.291 565 830.5V858.5C565 860.709 563.209 862.5 561 862.5H469C466.791 862.5 465 860.709 465 858.5V830.5Z"
                  fill={cyp2e1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_10"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={488.414} y={849.948}>
                    CYP2E1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2e1"
                groupId="gene-snps_10"
                genePalette={cyp2e1}
                startX={473}
                startY={864.5}
                snpCount={getGeneSnpCount("CYP2E1", expectedSnps, geneColors)}
              />
            </g>
            <g id="Report titles_2">
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={466.232} y={292.12}>
                  Detox Phase I{" "}
                </tspan>
                <tspan x={444.286} y={320.12}>
                  (Biotransformation)
                </tspan>
              </text>
            </g>
            <path
              id="Vector 423"
              d="M685 585.225L580 373H565M685 585.225L580 428.058H565M685 585.225L580 478.612H565M685 585.225L580 529.165H565M685 585.225H565M685 585.225L580 635.278H565M685 585.225L580 687.333H565M685 585.225L580 740.89H565M685 585.225L580 790.943H565M685 585.225L580 845H565"
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Frame 468">
              <rect
                x={685.7}
                y={536.2}
                width={134.6}
                height={102.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block">
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={719.982} y={580.267}>
                    Activated{" "}
                  </tspan>
                  <tspan x={708.676} y={604.267}>
                    intermediates
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Frame 468_2">
              <rect
                x={187.7}
                y={459.7}
                width={154.6}
                height={234.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block_2">
                <text
                  id="H2 Header"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={18}
                  letterSpacing="0em"
                >
                  <tspan x={203} y={507.147}>
                    Toxins
                  </tspan>
                </text>
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={203} y={539.767}>
                    Enter through:{" "}
                  </tspan>
                  <tspan x={203} y={563.767}>
                    {" "}
                  </tspan>
                  <tspan x={224} y={587.767}>
                    Lung{" "}
                  </tspan>
                  <tspan x={224} y={611.767}>
                    Skin{" "}
                  </tspan>
                  <tspan x={224} y={635.767}>
                    Gut/Intestine{" "}
                  </tspan>
                  <tspan x={224} y={659.767}>
                    (small)
                  </tspan>
                </text>
              </g>
            </g>
            <path
              id="Vector 423_2"
              d="M343 585.225L342.373 584.914L342.233 585.196L342.351 585.487L343 585.225ZM448 373V372.3H447.565L447.373 372.69L448 373ZM463 373L456 368.959V377.041L463 373ZM448 428.058V427.358H447.626L447.418 427.669L448 428.058ZM463 428.058L456 424.017V432.1L463 428.058ZM448 478.612V477.912H447.707L447.501 478.121L448 478.612ZM463 478.612L456 474.57V482.653L463 478.612ZM448 529.165V528.465H447.825L447.67 528.548L448 529.165ZM463 529.165L456 525.124V533.207L463 529.165ZM463 585.225L456 581.183V589.266L463 585.225ZM448 635.278L447.699 635.91L447.842 635.978H448V635.278ZM463 635.278L456 631.236V639.319L463 635.278ZM448 687.333L447.512 687.835L447.716 688.033H448V687.333ZM463 687.333L456 683.292V691.374L463 687.333ZM448 740.89L447.42 741.281L447.628 741.59H448V740.89ZM463 740.89L456 736.848V744.931L463 740.89ZM448 790.943L447.377 791.261L447.571 791.643H448V790.943ZM463 790.943L456 786.901V794.984L463 790.943ZM448 845L447.351 845.262L447.528 845.7H448V845ZM463 845L456 840.959V849.041L463 845ZM343 585.225L343.627 585.535L448.627 373.31L448 373L447.373 372.69L342.373 584.914L343 585.225ZM448 373V373.7H456.7V373V372.3H448V373ZM343 585.225L343.582 585.614L448.582 428.447L448 428.058L447.418 427.669L342.418 584.836L343 585.225ZM448 428.058V428.758H456.7V428.058V427.358H448V428.058ZM343 585.225L343.499 585.716L448.499 479.103L448 478.612L447.501 478.121L342.501 584.734L343 585.225ZM448 478.612V479.312H456.7V478.612V477.912H448V478.612ZM343 585.225L343.33 585.842L448.33 529.783L448 529.165L447.67 528.548L342.67 584.607L343 585.225ZM448 529.165V529.865H456.7V529.165V528.465H448V529.165ZM343 585.225V585.925H456.7V585.225V584.525H343V585.225ZM343 585.225L342.699 585.857L447.699 635.91L448 635.278L448.301 634.646L343.301 584.593L343 585.225ZM448 635.278V635.978H456.7V635.278V634.578H448V635.278ZM343 585.225L342.512 585.727L447.512 687.835L448 687.333L448.488 686.831L343.488 584.723L343 585.225ZM448 687.333V688.033H456.7V687.333V686.633H448V687.333ZM343 585.225L342.42 585.616L447.42 741.281L448 740.89L448.58 740.498L343.58 584.833L343 585.225ZM448 740.89V741.59H456.7V740.89V740.19H448V740.89ZM343 585.225L342.377 585.543L447.377 791.261L448 790.943L448.623 790.625L343.623 584.907L343 585.225ZM448 790.943V791.643H456.7V790.943V790.243H448V790.943ZM343 585.225L342.351 585.487L447.351 845.262L448 845L448.649 844.738L343.649 584.963L343 585.225ZM448 845V845.7H456.7V845V844.3H448V845Z"
              fill="#282828"
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationDetoxificationPhase1Diagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={871}
    viewBox="0 142 1024 871"
    fill="none"
    {...props}
  >
    <MethylationDetoxificationPhase1DiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18382_42117">
        <rect width={1024} height={1013} fill="white" />
      </clipPath>
      <clipPath id="clip1_18382_42117">
        <rect width={1024} height={871} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationDetoxificationPhase1Diagram;
